import {
    CheckListItemImportanceLevel,
    MyAccountTripWithChecklistFragment,
} from "generated/graphql";

import { getSystemCheckListItems } from "./useChecklist";
import { useMyTripForBookingId } from "./useTrips";

export const getAllChecklistItemsBasic = (
    trip: MyAccountTripWithChecklistFragment,
): {
    importanceLevel: CheckListItemImportanceLevel;
    isChecked: boolean;
}[] => {
    return [
        ...getSystemCheckListItems(trip).map((item) => ({
            isChecked: item.isCompleted,
            importanceLevel: CheckListItemImportanceLevel.Required,
        })),
        ...trip.checklistItems.map((item) => ({
            importanceLevel: item.importanceLevel,
            isChecked: item.isChecked,
        })),
    ];
};

export const countChecklistItems = (
    trip: MyAccountTripWithChecklistFragment,
) => {
    return getAllChecklistItemsBasic(trip)
        .filter((item) => !item.isChecked)
        .reduce(
            (acc, item) => {
                switch (item.importanceLevel) {
                    case CheckListItemImportanceLevel.HighlyRecommended:
                        acc.recommended += 1;
                        break;
                    case CheckListItemImportanceLevel.Recommended:
                        acc.recommended += 1;
                        break;
                    case CheckListItemImportanceLevel.Required:
                        acc.required += 1;
                        break;
                }
                return acc;
            },
            {
                recommended: 0,
                required: 0,
            },
        );
};

export const totalChecklistItemCount = (
    trip: MyAccountTripWithChecklistFragment,
) => {
    const { recommended, required } = countChecklistItems(trip);
    return recommended + required;
};

type BookingLike = { trips: MyAccountTripWithChecklistFragment[] };

export const checklistItemCountForBooking = (booking?: BookingLike | null) => {
    return (booking?.trips ?? []).map(countChecklistItems).reduce(
        (acc, item) => ({
            recommended: acc.recommended + item.recommended,
            required: acc.required + item.required,
        }),
        { recommended: 0, required: 0 },
    );
};

export const useChecklistCounts = (bookingId?: string) => {
    const rootTrip = useMyTripForBookingId(bookingId);

    if (!rootTrip?.booking?.trips) {
        return {
            recommended: 0,
            required: 0,
        };
    }

    return rootTrip.booking.trips.map(countChecklistItems).reduce(
        (acc, item) => ({
            recommended: acc.recommended + item.recommended,
            required: acc.required + item.required,
        }),
        { recommended: 0, required: 0 },
    );
};
